AppTabs.createTab( {

name: 'reports',
icon: 'file-alt',
text: 'Reports',
actionElementClasses: [ 'report-link' ],

//preload: 'vmReports',
create: function(init) {
	'use strict'

	const tab = this;
	const reportView = AppTabs.getTab('report').controller;
	const fields = [
		{
			label: 		'Project #',
			columnName: 'JobNumber',
			order:		'asc',
			type:       'project-link',
		},
		{
			label: 		'Sample #',
			columnName: 'SampleNumber',
			type:       'sample-link',
		},
		{
			label: 		'Sample Description',
			columnName: 'SampleDescription',
		},
		{
			label: 		'Sample From Date',
			columnName: 'SampleFromDate',
			type:       'date',
		},
		{
			label: 		'Sample To Date',
			columnName: 'SampleToDate',
			type:       'date',
		},
		{
			label: 		'Test',
			columnName: 'TestName',
		},
		{
			label: 		'Analyte',
			columnName: 'Analyte',
		},
		{
			label: 		'D/T',
			columnName: 'DissolvedOrTotal',
			type:       'select',
			isEditable:	true,
			options: [
				{ value: null, label: '' },
				{ value: 'D', label: 'D' },
				{ value: 'T', label: 'T' },
			],
		},
		{
			label: 		'D/A',
			columnName: 'DryWtOrAsIsBasis',
			type:       'select',
			isEditable:	true,
			options: [
				{ value: null, label: '' },
				{ value: 'D', label: 'D' },
				{ value: 'A', label: 'A' },
			],
		},
		{
			label: 		'Report Units',
			columnName: 'ReportUnits',
			isEditable:	true,
			type:		'combobox',
			datalist:	'units'
		},
		{
			label: 		'Report Results',
			columnName: 'ReportResults',
			isEditable:	true,
		},
		{
			label: 		'Report LOD',
			columnName: 'ReportLOD',
			isEditable:	true,
		},
		{
			label: 		'Report LOQ',
			columnName: 'ReportLOQ',
			isEditable:	true,
		},
		{
			label: 		'Dilution',
			columnName: 'Dilution',
			isEditable:	true,
		},
		{
			label: 		'Dec Places',
			columnName: 'DecimalPlaces',
			isEditable:	true,
		},
		{
			label: 		'Report Original',
			columnName: 'ReportOriginal',
		},
		{
			label: 		'Original Units',
			columnName: 'Units',
		},
		{
			label: 		'Original Result',
			columnName: 'Result',
		},
		{
			label: 		'LOD',
			columnName: 'LOD',
		},
		{
			label: 		'LOQ',
			columnName: 'LOQ',
		},
		{
			label: 		'Analyzed Date',
			columnName: 'AnalyzedDate',
			type:       'date',
		},
		{
			label: 		'Analyzed Time',
			columnName: 'AnalyzedTime',
		},
		{
			label: 		'Analyst',
			columnName: 'Analyst'
		},
		{
			label: 		'Status',
			columnName: 'JobStatus'
		},
		{
			label: 		'QA Code',
			columnName: 'QAFlag'
		},
		{
			label: 		'Reported',
			columnName: 'ReportedDate',
			type:       'date',
		},
	];

	init.setDataTableArgs( {

		tableId: 		'#datatable-reports',

		primaryKey: 	'ResultID',

		// tables used by DataTables actions
		readTableName: 	null,
		editTableName:	'tblResults',

		hasColumnFilters: 	true,
		canSearch: 			true,
		canSort:			true,
		drawWhen:           false,

		// Ajax action endpoints
		// these also serve as flags as to whether to show the editor buttons or add the autofill eventListener
		actionData:			'datatable_reports',
		//actionAutofill:	'datatable_autofill_enter_results',
		//actionCreate:		'datatable_create_enter_results',
		actionEdit:			'datatable_edit_results',
		//actionRemove:		'datatable_remove_enter_results',
		exportActions:      true,

		// Adds additional data fields to ajax requests when drawing the table
		ajaxDataCallback : function( data, settings ) {
			const vmReports         = tab.controller;
			data.clientID 			= (vmReports.client && ! vmReports.projectNumber) ? vmReports.client.id 	: -1;
			data.projectName		= ! vmReports.projectNumber ? vmReports.projectName : null;
			data.addressID 			= (vmReports.address && ! vmReports.projectNumber) ? vmReports.address.id 	: -1;
			data.projectNumber		= ( ! vmReports.sampleNumber) ? vmReports.projectNumber : null;
			data.sampleNumber		= vmReports.sampleNumber;
			data.jobStatus 			= vmReports.jobStatus ? vmReports.jobStatus.id : null;
			data.sampleFromDate 	= vmReports.sampleFromDate;
			data.sampleToDate 		= vmReports.sampleToDate;
			return data;
		},

		fields: fields,

	} );

	init.setController( new TabControllerVue({
		el: '#reports-datatable-filters',
		computed: {
			clients: function() {
				return LocalStorageManager.get( 'clientList' );
			},
			jobStatuses: function() {
				return LocalStorageManager.get( 'jobStatusOptions' );
			},
			faGenerate: function() {
				return 'fas fa-' + ( ( this.reportFormat != 'docx' && this.reportDestinationEmailAddress ) ? 'envelope' : 'download' ) ;
			}
		},
		methods: {
			resetData() {
				this.client         = null;
				this.projectName    = null;
				this.projectNames   = [];
				this.projectNameId  = null;
				this.address        = null;
				this.addresses      = [];
				this.projectNumber  = null;
				this.projectNumbers = [];
				this.sampleNumber   = null;
				this.sampleNumbers  = [];
				this.jobStatus      = null;
				this.sampleFromDate = null;
				this.sampleToDate   = null;

				this.fetchingAddresses       = false;
				this.fetchingProjectNames    = false;
				this.fetchingSampleNumbers   = false;
				this.fetchingProjectNumbers  = false;
				this.reportDestinationEmailAddress = null;
				this.reportFormat            = 'pdf-with-attachments';
				this.reportType              = 'standard';
				this.reportLocation          = 'neenah';
				this.reportPeriod            = null;
				this.licenseMonitoringNumber = null;
				
				this.ClientLoginComment = null;
			},
			onOpenTab: function() {
				if ( ! this.projectNumber ) {
					this.ajaxAdjustFilters( 'clear' );
				}
			},
			ajaxAdjustFilters: function(update, onSuccess = null, onError = null){
				const _this = this;
				this.fetchingAddresses       = true;
				this.fetchingProjectNames    = true;
				this.fetchingSampleNumbers   = true;
				this.fetchingProjectNumbers  = true;
				const data = {
					action:        'adjust_result_filtering',
					update,
					addresses:     true,
					report_emails: true,
					clientId:      this.client ? this.client.id : null,
					projectNumber: this.projectNumber,
					sampleNumber:  this.sampleNumber,
				};
				if ( this.projectName !== null )
					data.projectName = this.projectName;
				window.ajaxCall({
					data,
					onSuccess : function( { data } ) {
						_this.lockUpdates( 'ajaxAdjustFilters' );
						if ( 'clientId' in data && ( _this.client == null || _this.client.id != data.clientId ) ) {
							_this.client = ( data.clientId != null && _this.clients
								&& _this.clients.find( client => client.id == data.clientId ) ) || _this.client;
						}
						if ( 'projectName' in data ) {
							_this.projectName = data.projectName;
						}
						if ( 'projectNames' in data ) {
							_this.projectNames = data.projectNames;
							_this.projectName = _this.projectNames
								&& _this.projectNames.find( projectName => projectName == _this.projectName ) || _this.projectName;
						}
						if ( 'projectNameId' in data ) {
							_this.projectNameId = data.projectNameId;
						}
						if ( 'projectNumber' in data && data.projectNumber && data.projectNumber.length ) {
							_this.projectNumber = data.projectNumber;
						}
						if ( 'projectNumbers' in data ) {
							_this.projectNumbers = data.projectNumbers;
							if ( _this.client )
								_this.projectNumber = _this.projectNumbers
									&& _this.projectNumbers.find( projectNumber => projectNumber == _this.projectNumber ) || _this.projectNumber;
						}
						if ( 'sampleNumber' in data ) {
							_this.sampleNumber = data.sampleNumber;
						}
						if ( 'sampleNumbers' in data ) {
							_this.sampleNumbers = data.sampleNumbers;
							_this.sampleNumber = _this.sampleNumbers.find( sampleNumber => sampleNumber == _this.sampleNumber ) || _this.sampleNumber;
						}
						if ( 'addresses' in data ) {
							_this.addresses = data.addresses;
							if ( _this.addresses && _this.addresses.length ) {
								if (  _this.address )
									_this.address = _this.addresses.find( address => address.id == _this.address.id ) || _this.address;
								if ( _this.address == null )
									_this.address = _this.addresses[0];
							} else {
								this.address = null;
							}
						}
						if ( 'report_emails' in data ) {
							_this.reportDestinationEmailAddress = data.report_emails;
						}
						_this.unlockUpdatesLater( 'ajaxAdjustFilters', onSuccess );
						_this.fetchingAddresses      = false;
						_this.fetchingProjectNames   = false;
						_this.fetchingSampleNumbers  = false;
						_this.fetchingProjectNumbers = false;
					},
					onError : function( response ) {
						_this.fetchingAddresses      = false;
						_this.fetchingProjectNames   = false;
						_this.fetchingSampleNumbers  = false;
						_this.fetchingProjectNumbers = false;
						alert( 'Could not update filters' );
						typeof onError == 'function' && onError();
					},
				});
			},
			ajaxLoadProjectNames(prefix = '') {
				const _this = this;
				_this.fetchingProjectNames = false;

				window.ajaxCall({
					data : {
						action: 'get_project_names_by_client',
						clientId: this.client ? this.client.id : null,
						prefix,
					},
					onSuccess( response ) {
						if ((response.data && response.data.length) || !prefix) {
							_this.projectNames = response.data;
							_this.fetchingProjectNames = false;
						} else
							_this.ajaxLoadProjectNames();
					},
					onError( response ) {
						_this.fetchingProjectNames = false;
						alert( _this.client
							? 'Could not load Project Names for ' + _this.client.text
							: 'Could not load Project Names' );
					},
				});
			},
			ajaxLoadProjectNumbers(prefix = '') {
				if ( ! this.client ) {
					this.projectNumbers = ['loading...'];
				}
				const _this = this;
				_this.fetchingProjectNumbers = true;

				window.ajaxCall({
					data : {
						action: 'get_project_numbers_by_client',
						clientId: this.client ? this.client.id : null,
						prefix,
					},
					onSuccess( response ) {
						if ((response.data && response.data.length) || !prefix) {
							_this.projectNumbers = response.data;
							_this.fetchingProjectNumbers = false;
						} else
							_this.ajaxLoadProjectNumbers();
					},
					onError( response ) {
						_this.fetchingProjectNumbers = false;
						alert( _this.client
							? 'Could not load Project Numbers for ' + _this.client.text
							: 'Could not load Project Numbers' );
					},
				});
			},
			ajaxLoadSampleNumbers(prefix = '') {
				if ( ! this.client ) {
					this.sampleNumbers = ['loading...'];
				}
				const _this = this;
				_this.fetchingSampleNumbers = true;

				window.ajaxCall({
					data : {
						action: 'get_sample_numbers_by_client',
						clientId: this.client ? this.client.id : null,
						prefix,
					},
					onSuccess( response ) {
						if ((response.data && response.data.length) || !prefix) {
							_this.sampleNumbers = response.data;
							_this.fetchingSampleNumbers = false;
						} else {
							_this.ajaxLoadSampleNumbers();
						}
					},
					onError( response ) {
						_this.fetchingSampleNumbers = false;
						alert( _this.client
							? 'Could not load Sample Numbers for ' + _this.client.text
							: 'Could not load Sample Numbers' );
					},
				});
			},
			loadProject: function( jobNumber, onSuccess = null){
				// TODO: Check & complete
				this.projectNumber = parseInt( jobNumber );
				if ( typeof onSuccess == 'function' ) { onSuccess(); }
			},
			loadProjectName: function( projectId, onSuccess = null, onError = null){
				const _this = this;
				window.ajaxCall({
					data : {
						action: 'get_long_project',
						id: projectId,
					},
					onSuccess : function( { data } ) {
						_this.projectNameId      = data.ProjectID;
						_this.projectName        = data.ProjectName;
						_this.client             = ( data.ClientID != null && _this.clients
							&& _this.clients.find( client => client.id == data.ClientID ) ) || null;
						if ( typeof onSuccess == 'function' ) { onSuccess(); }
					},
					onError : function( response ) {
						alert( 'Could Not Load Project' );
						if ( typeof onSuccess == 'function' ) { onError(); }
					},
				});
			},
			search() { tab.drawTable(); },
			markReported: function() {
				if ( ! this.projectNumber && ! this.projectNameId ) { return; }

				const _this = this;
				window.ConfirmationModalManager.show({
					title: 'Mark Reported',
					message: _this.projectNumber != null
						? 'Mark Project # ' + _this.projectNumber + ' as reported?'
						: 'Mark "' + _this.projectName + '" Project as reported?',
					buttonText: 'Mark Reported',
					callback: function() {
						const data = { action: 'mark_project_reported' };
						if ( _this.projectNumber )
							data.jobNumber = _this.projectNumber;
						else
							data.projectNameId = _this.projectNameId;
						window.ajaxCall({
							data,
							onSuccess : tab.drawTable,
							onError : function( response ) {
								alert('Could not mark Project #' + _this.projectNumber + " as 'Reported'" );
							},
						});
					}
				});
			},
			generateReport: function(emailAddress){
				const data = {
					type:     this.reportType,
					location: this.reportLocation,
					format:   this.reportFormat == 'pdf-with-attachments' ? 'pdf' : this.reportFormat,
				};

				if ( this.projectNumber == null )
					data.projectId = this.projectNameId;
				else
					data.jobNumber = this.projectNumber;

				if ( this.reportFormat == 'pdf-with-attachments' )
					data.attachments = true;

				if ( this.reportPeriod != null )
					data.reportPeriod = this.reportPeriod;

				if ( this.client != null && this.projectNameId == null )
					data.clientIds = [ this.client.id ];

				if ( this.jobStatus != null )
					data.jobStatus = this.jobStatus.id;

				if ( this.sampleFromDate != null )
					data.sampleFromDate = this.sampleFromDate;

				if ( this.sampleToDate != null )
					data.sampleToDate = this.sampleToDate;

				if ( this.licenseMonitoringNumber != null )
					data.licenseMonitoringNumber = this.licenseMonitoringNumber;

				if ( this.reportFormat != 'docx' && emailAddress )
					data.emailTo = emailAddress;

				reportView.OpenReport( data, tab );
			},
			downloadReport: function() {
				this.generateReport();
			},
			viewReport: function() {
				this.generateReport();
			},
			emailReport: function() {
				this.generateReport( this.reportDestinationEmailAddress );
			},
			updateReportDestinationEmailAddress: function( onSuccess ) {
				if ( this.client ) {
					const _this = this;
					window.ajaxCall({
						data : {
							action: 'get_autoreport_emails',
							clientId: this.client ? this.client.id : null,
						},
						onSuccess : function( response ) {
							_this.lockUpdates( 'updateReportDestinationEmailAddress' );
							_this.reportDestinationEmailAddress = response.data;
							_this.unlockUpdatesLater( 'updateReportDestinationEmailAddress', onSuccess );
						},
					});
				} else {
					_this.lockUpdates( 'updateReportDestinationEmailAddress' );
					_this.reportDestinationEmailAddress = null;
					_this.unlockUpdatesLater( 'updateReportDestinationEmailAddress', onSuccess );
				}
			},

			doElementAction: function(target, elClass, event) {
				if ( target.dataset.projectId )
					this.loadProjectName( target.dataset.projectId, tab.drawTableShow );
				else
					this.loadProject( target.dataset.jobNumber, tab.drawTableShow );
			},
		},
		watch: {
			client: function( newValue, oldValue ) {
				if ( newValue == oldValue || ( newValue && oldValue && newValue.id == oldValue.id ) ) { return; }
				if ( this.getUpdateLockLevel() ) { return; }
				this.ajaxAdjustFilters( 'client' );
				if ( !newValue ) {
					this.address = null;
				}
				const vm = this;
				window.ajaxCall({
	                data : {
	                    action: 'get_client_login_comment',
	                    client_id: vm.client? vm.client.id : 0
	                },
	                onSuccess : function( response ) {
						const clientData = response.data;

						vm.ClientLoginComment = clientData.ClientLoginComments;

						typeof onSuccess == 'function' && onSuccess();
	                },
					onError: function() { typeof onError == 'function' && onError() },
	            });
			},
			projectName: function( value, oldValue ) {
				if ( value == oldValue || this.getUpdateLockLevel() ) { return; }
				this.ajaxAdjustFilters( 'projectName' );
			},
			projectNumber: function( value, oldValue ) {
				if ( value == oldValue || this.getUpdateLockLevel() ) { return; }
				this.ajaxAdjustFilters( 'project' );
			},
			sampleNumber: function( value, oldValue ) {
				if ( value == oldValue || value == null || this.getUpdateLockLevel() ) { return; }
				this.ajaxAdjustFilters( 'sample' );
			},
		}
	}) );

}

} );
